<script setup>
  defineProps({
    artist: {
      required: false,
      type: Object,
    },
    isLoading: {
      required: false,
      type: Boolean,
    },
    customBottom: {
      required: false,
      default: "-right-1 bottom-10",
      type: String,
    },
    customSize: {
      required: false,
      default: "w-[136px] h-[136px] md:w-[156px] md:h-[156px]",
      type: String,
    },
  })
</script>
<template>
  <div class="flex flex-col justify-center items-center relative w-full">
    <template v-if="isLoading">
      <Skeleton
        class="w-max-[100%] !w-[111px] md:!w-[156px] !h-[111px] md:!h-[156px]"
        shape="circle"
      />
      <Skeleton class="mt-3 !w-[100px] md:!w-[120px] !h-[20px]" />
    </template>
    <template v-else>
      <div class="flex flex-col justify-between">
        <div class="rounded-full overflow-hidden" :class="customSize">
          <img
            draggable="false"
            class="object-cover w-full"
            :src="artist.photo_url"
            alt="Artist Image"
          />
        </div>
        <CheckDecagramIcon
          v-if="artist?.is_verified"
          class="w-[24px] md:w-[30px] absolute"
          :class="customBottom"
        />
        <div
          class="mt-3 text-[13px] md:text-[18px] truncate w-full text-center"
        >
          {{ artist.name }}
        </div>
      </div>
    </template>
  </div>
</template>
